import React, { useState } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import CustomButton from '../../component/CustomButton';
import BillingPage from './BillingPage';
import GreyHeader from '../../component/GreyHeader';

const ManageBilling = (props) => {
	const { t } = useTranslation('translation', { keyPrefix: 'billingPage' });
	const { user } = props;
	const userRole = user.roles[0];
	const [tabKey, setTabKey] = useState(1);
	const headerOptions = {
		title: t('titleBilling'),
		renderSubtitle: (
			<nav className="page-subtitle block">
				<CustomButton
					variant='subtitle'
					active={tabKey === 1}
					onClick={() => setTabKey(1)}
					ga_params={{ category: userRole, action: 'Change Contracts Tab', label: 'Contracts' }}
				>
					{t('btnContracts')}
				</CustomButton>
			</nav>
		)
	};

	return (
		<>
			<GreyHeader {...headerOptions} />

			{tabKey === 1 &&
				<BillingPage />
			}
		</>
	);
}


export default connect(
	state => ({
		user: state.user.user,
	}),
	null
)(ManageBilling);
